/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateResult } from '../../models/create-result';

export interface GetnotificationsAgentCreatedSchema$Params {
}

export function getnotificationsAgentCreatedSchema(http: HttpClient, rootUrl: string, params?: GetnotificationsAgentCreatedSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateResult>> {
  const rb = new RequestBuilder(rootUrl, getnotificationsAgentCreatedSchema.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateResult>;
    })
  );
}

getnotificationsAgentCreatedSchema.PATH = '/api/hubs/notifications/AgentCreated';
